import { PieSkeleton, TextSkeleton } from "@/components/Skeletons";

export default function AllocationBlueprintSkeleton() {
  return (
    <div className="flex min-h-[calc(100dvh-170px)] gap-8">
      <AllocationBluePrintSectionSkeleton />
      <AllocationBluePrintSectionSkeleton />
    </div>
  );
}

export function AllocationBluePrintSectionSkeleton() {
  return (
    <div className="flex w-[calc(50%-1rem)] justify-center rounded-lg bg-neutral-500 p-6">
      <div className="flex flex-col items-center gap-8">
        <PieSkeleton width={35} height={35} />
        <div className="flex gap-6 rounded-md border border-neutral-500 bg-white p-6 shadow-light">
          <TextSkeleton width={9} height={3} />
          <TextSkeleton width={9} height={3} />
          <TextSkeleton width={9} height={3} />
        </div>
      </div>
    </div>
  );
}
